import {
  APPLE_WATCH_PRICES,
  OURA_DISCOUNT_CURRENCY,
  Price,
  Product,
  ProductKey,
  thermometerKeys,
} from '@naturalcycles/shared'

export const ouraRingDiscount = '10%'

export function getOuraDiscountAsPrice(country: string): Price {
  if (OURA_DISCOUNT_CURRENCY[country] === 'EUR') {
    return new Price('40[EUR]')
  }
  return new Price('40[USD]')
}

export function getOuraRingPrice(country: string): string {
  if (OURA_DISCOUNT_CURRENCY[country] === 'EUR') return '€329'
  return '$299'
}

export function getOuraRingDiscountedPrice(country: string): string {
  if (OURA_DISCOUNT_CURRENCY[country] === 'EUR') return '€289'
  return '$259'
}

// Convenient method for measuring device page.
// Returns bundle price for annual subscription.
// TODO: move to backend if we decide to implement AB test 155
export function getBundlePrice(product: Product, country: string): Price | undefined {
  if (product.key === ProductKey.OURA_RING_DISCOUNT) {
    if (OURA_DISCOUNT_CURRENCY[country] === 'EUR') return new Price('274[EUR]')
    return new Price('259[USD]')
  }
  if (product.key === ProductKey.APPLE_WATCH) {
    if (APPLE_WATCH_PRICES[country]) return new Price(APPLE_WATCH_PRICES[country])
    return new Price(APPLE_WATCH_PRICES['US'])
  }
  if (thermometerKeys.includes(product.key)) {
    return new Price(`0[${product.price.currency}]`)
  }
  return undefined
}
